export const google = 'gMap';
export const OSM = 'osMap';
export default { google, OSM };
